// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"af19510f","884":"3484668d"}[chunkId] + ".chunk.js";
};